
function Form() {
  // Room Reservation Form
  // checkInDate=2020-10-21&checkOutDate=2020-10-22&locale=es&currency=EUR&items[0][adults]=1&items[0][children]=0&items[0][infants]=0
  const elFormRoom = document.querySelector('.mphb_sc_search-form');
  if (elFormRoom) {
    // Rewrite form parameters
    elFormRoom.addEventListener('submit', (e) => {
      e.preventDefault();
      console.log(`Submit form`, e);

      let field;
      let sURL = '//direct-book.com/properties/hotelpalaciodesamaniego?';

      field = elFormRoom.querySelector('input[name="mphb_check_in_date"][type="hidden"]');
      sURL += `checkInDate=${field.value}`;

      field = elFormRoom.querySelector('input[name="mphb_check_out_date"][type="hidden"]');
      sURL += `&checkOutDate=${field.value}`;
      
      field = elFormRoom.querySelector('select[name="mphb_adults"]');
      sURL += `&items[0][adults]=${field.value}`;
      
      field = elFormRoom.querySelector('select[name="mphb_children"]');
      sURL += `&items[0][children]=${field.value}`;
      
      field = document.querySelector('html');
      console.log(`HTML`, field);
      sURL += `&locale=${field.getAttribute('lang').split('-')[0]}`;

      sURL += '&currency=EUR';
      sURL += '&items[0][infants]=0';

      // console.log(`URL`, sURL);

      // window.location = sURL;
      window.open(sURL, '_blank');

      return false;
    })
  }
}

export default Form;